import HandymanIcon from '@mui/icons-material/Handyman';
import { Box, GlobalStyles, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { I18nContextProvider, useTranslate } from 'react-admin';

import { getThemeForEnvironment } from '@sh4res/bo-common/theme';

import { i18nProvider } from '@Utils/providers/i18nProvider';

const MaintenanceContent = () => {
  const translate = useTranslate();

  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        background: '#f8f8f8',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3,
          padding: 6,
          background: '#ffffff',
          borderRadius: '30px',
          boxShadow: '0px 0px 24px rgba(89, 79, 244, 0.04)',
          maxWidth: 480,
          textAlign: 'center',
        }}>
        <HandymanIcon sx={{ fontSize: 64, color: 'primary.main' }} />
        <Typography variant="h1">{translate('maintenance_page.title')}</Typography>
        <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {translate('maintenance_page.message')}
        </Typography>
      </Box>
    </Box>
  );
};

export const MaintenancePage = () => (
  <ThemeProvider theme={getThemeForEnvironment()}>
    <I18nContextProvider value={i18nProvider}>
      <GlobalStyles
        styles={{
          body: { margin: 0 },
        }}
      />
      <MaintenanceContent />
    </I18nContextProvider>
  </ThemeProvider>
);
